import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { RestauranteService } from 'src/app/services/restaurante.service';
import { Restaurante } from 'src/app/models/restaurante';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from '../../../services/global';
import { PlatosService } from 'src/app/services/platos.service';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';

@Component({
  selector: 'app-pagina-bar',
  templateUrl: './pagina-bar.component.html',
  styleUrls: ['./pagina-bar.component.css']
})
export class PaginaBarComponent implements OnInit {
  @ViewChild('imgQR', { static: true }) imgQR: ElementRef;

  arrayBotones = [];
  url = "";
  secciones = [];
  closeResult: string;
  nuevaSeccion: any;
  selectedFile: File = null;
  imageSrc: any;
  filesToUpload: any;
  file: any;
  textImg: any;
  textPrecio: string;
  urlCarta: string;
  qrOk: boolean = false;
  tempGuid: string;
  arrayCarta: any;
  cartaOk: boolean = false;
  tempSeccion: any;
  visibilidadSecciones: Array<any> = [];
  follows: string;
  userLogin: any;
  resultInsertFollow: any;
  cartaQR: boolean = false;
  follow: boolean = false;
  restauranteClickcado: string = '';
  marcaId: string = '';
  urlContactoWhatsapp: string = "";
  pos: any = null;
  pantallaCarga: boolean = false;
  lang: string = "en";
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];
  diaSemanaHoy: any = 0;

  publicaciones: any;
  stars: { value: number, filled: boolean }[] = [];

  @ViewChild("btnLike", null) btnLike: { nativeElement: any; }
  @Input() establecimiento: any;
  @Output() platoSeleccionado = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rService: RestauranteService,
    private modalService: NgbModal,
    private pService: PlatosService,
    private fService: FollowService,
    private mService: MetricaService) {

  }

  ngOnInit() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.url = GLOBAL.url;
    this.lang = navigator.language.split('-')[0];
    this.route.params.subscribe(result => {
      // this.restaurante.id = result.id;
      // this.arrayBotones = GLOBAL.arrayBotones(result.id);
      this.arrayBotones = GLOBAL.arrayBotones(result.slug);
    });

    let currentUrl = window.location.href;

    if (currentUrl.indexOf("QR") != -1) {
      this.cartaQR = true;
      this.arrayBotones = GLOBAL.arrayBotonesQR(this.establecimiento.id);
      // this.arrayBotones = GLOBAL.arrayBotonesQR(this.restaurante.slug);

    }

    this.route.queryParamMap.subscribe((params) => {
      if (params.get('nombreMarca') != null && params.get('nombreMarca') != "") {

        if (params.get('restauranteClickcado') != null && params.get('restauranteClickcado') != "") {
          this.restauranteClickcado = params.get('restauranteClickcado');
        }

        if (params.get('marcaId') != null && params.get('marcaId') != "") {
          this.marcaId = params.get('marcaId');
        }

        this.addMetricaMapaMarca();
      }
    });

    const hoy = new Date();
    this.diaSemanaHoy = hoy.getDay() - 1;

    if (this.diaSemanaHoy < 0) {
      this.diaSemanaHoy = 6;
    }

    this.formatearDatosRestaurante();
  }

  formatearDatosRestaurante() {
    this.generarImagenesSecciones(this.establecimiento);
    this.generarArrayVisibilidad();
    this.getPublicaciones(this.establecimiento.id);

    this.establecimiento.horario = [];

    this.diasSemana.forEach((dia, index) => {
      this.establecimiento.horario[index] = this.establecimiento["horario_" + dia];
    });
  }

  getInfoCarta() {

    let textCarta = "";

    if (this.lang != "es") {

      if (this.establecimiento["traduccion"][this.lang] != undefined) {

        let tradCarta = this.establecimiento["traduccion"][this.lang].carta;

        if (tradCarta != "" && tradCarta != null) {
          textCarta = tradCarta;
        }

      } else {
        textCarta = this.establecimiento.carta;
      }

    } else {
      textCarta = this.establecimiento.carta;
    }

    return textCarta.replace(/\r\n|\r|\n/g, '<br>');
  }

  addMetricaMapaMarca() {

    let modeloMetrica = {
      mapa_marca_id: this.marcaId,
      establecimiento_id: this.restauranteClickcado
    }

    modeloMetrica["tipo_interaccion"] = 2;

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Click guardada en metrica");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });

    modeloMetrica["tipo_interaccion"] = 4;

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Destino Ok guardada en metrica");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });
  }

  generarArrayVisibilidad() {
    for (let seccion of this.establecimiento.secciones) {
      this.visibilidadSecciones[(<any>seccion).id] = false;
    }
  }

  generarImagenesSecciones = (restaurante) => {
    console.log('result>', restaurante);
    for (let i = 0; i < (<any>this.establecimiento).secciones.length; i++) {
      let fotosSeccion = [];
      for (let z = 0; z < (<any>this.establecimiento).secciones[i].platos_secciones.length; z++) {
        fotosSeccion.push({
            thumbImage: GLOBAL.url + (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.img
          , descripcion: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.descripcion
          , alergenos: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.alergenos
          , nombrePlato: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.nombre_plato
          , precioPlato: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.precio_plato
          , hastagPlatoMarca: this.obenerTiposTags((<any>this.establecimiento).secciones[i].platos_secciones[z].plato.tags, 'marca')
          , hastagPlatoNormal: this.obenerTiposTags((<any>this.establecimiento).secciones[i].platos_secciones[z].plato.tags, 'normal')
          , guidPlato: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.guid
          , idPlato: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.id
          , slugPlato: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.slug
          , traduccion: (<any>this.establecimiento).secciones[i].platos_secciones[z].plato.traduccion
        });
      }
      (<any>this.establecimiento).secciones[i].fotoPlatos = fotosSeccion;
    }
  }

  imagenPerfilError = (event) => {
    event.target.src = GLOBAL.url + "no-photo-available.png";
  }

  // CLICK EN IMAGEN
  imageClick(event) {
    console.log("ir al plato");
  }

  obtenerDescripcionPlatoJSON = (cadena) => {
    //Devolvemos el valor del JSON que recibimos
    return cadena == null ? '' : JSON.parse(cadena)[0].data;
  }

  obtenerAlergenosPlatoJSON = (alergenos) => {
    alergenos = JSON.parse(alergenos);

    var colAlergenos: string[] = [];

    if (alergenos) {
      //Devolvemos los iconos de los alergenos del plato

      for (var aler of alergenos) {
        //Cogemos la etiqueta y el icono
        colAlergenos.push(aler.icon);
      };
    }

    return colAlergenos;
  }

  myFunction() {
    console.log("Pinta la función");
    var popup = document.getElementById("mypopup");
    popup.classList.toggle("show");
  }

  obenerTiposTags(tags, tipo) {
    //Distinguimos los tipos de tags: Normal y Marca
    let tempTags = [];
    let temp = JSON.parse(tags);

    if (temp) {
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].tipo == 'marca' && tipo == 'marca') {
          tempTags.push(temp[i]);
        }

        if (temp[i].tipo == 'normal' && tipo == 'normal') {
          tempTags.push(temp[i]);
        }
      }
    }
    return tempTags;
  }

  cambiarVistaSeccion(seccionId: any) {
    if (this.visibilidadSecciones[seccionId]) {
      this.visibilidadSecciones[seccionId] = false;
    } else {
      this.visibilidadSecciones[seccionId] = true;
    }
  }

  goDetailPlato(slug: string, item: string) {
    let platoEncontrado = null;
    for (const seccion of this.establecimiento.secciones) {
      const ps = seccion.platos_secciones.find(ps => ps.plato.slug === slug);
      if (ps) {
        platoEncontrado = ps.plato;
        break;
      }
    }

    if (platoEncontrado) {
      this.platoSeleccionado.emit(platoEncontrado);
    }
  }

  getPublicaciones(establecimientoId: number) {
    this.pService.getPublicacionesByRestaurante(establecimientoId).subscribe(result => {
      if (result.result == 'ok') {
        this.publicaciones = result.allPublicaciones;
        for (let publicacion of this.publicaciones) {
          let fecha = new Date(publicacion.created_at);
          publicacion.fechaFormateada = fecha.getDay() + "/" + (fecha.getMonth() + 1) + "/" + fecha.getFullYear();
        }
        console.log(this.publicaciones);
      } else {
        console.log("error al obtener las publicaciones");
      }
    })
  }

  goDetailPublicacion(id) {
    this.router.navigate(['publicacion/' + id]);
  }

  navegar(direccion) {
    this.router.navigate([direccion]);
  }

  getNombrePlato(plato) {

    if (this.lang != "es") {

      if (plato["traduccion"][this.lang] != undefined) {

        let tradNombrePlato = plato["traduccion"][this.lang].nombre_plato;

        if (tradNombrePlato != "" && tradNombrePlato != null) {
          return tradNombrePlato;
        } else {
          return plato.nombrePlato;
        }

      } else {
        return plato.nombrePlato;
      }

    } else {
      return plato.nombrePlato;
    }
  }

  getNombreSeccion(seccion) {
    if (this.lang != "es") {

      if (seccion["traduccion"][this.lang] != undefined) {

        let tradNombre = seccion["traduccion"][this.lang].nombre;

        if (tradNombre != "" && tradNombre != null) {
          return tradNombre.toUpperCase();
        }

      } else {
        return seccion.nombre.toUpperCase();
      }

    } else {
      return seccion.nombre.toUpperCase();
    }
  }


}

